import { Banner, getSvgByName } from '@repo/ui';
import c from 'classnames';
import useGetKitIdParam from 'hooks/useGetKitIdParam';
import { useNavigate } from 'react-router-dom';
import useTaxaOverTime from 'services/insights/useTaxaOverTime';
import useKitSystemInfo from 'services/system-info/useKitSystemInfo';
import styles from './SubMetricBanner.module.css';
import useGetAnalysisVersionInfo from './useGetAnalysisVersionInfo';

const title = "Why aren't all my measurements showing?";
const content =
  'We regularly update our analysis to reflect the latest science. Only data from the same versions are comparable. Update all kits to the latest version to compare all data.';

type SubMetricBannerProps = {
  metricId?: number;
  className?: string;
};

export default function SubMetricBanner({
  metricId,
  className,
}: SubMetricBannerProps) {
  const navigate = useNavigate();
  const kitId = useGetKitIdParam();
  const { currentKit } = useKitSystemInfo();

  const { data } = useTaxaOverTime({
    kitId: currentKit?.id,
    metricId,
  });

  const { hasMultipleVersions } = useGetAnalysisVersionInfo(
    data,
    currentKit?.id,
  );

  function handleUpdate() {
    navigate('/results/update', {
      state: { from: `/results/${kitId}` },
    });
  }

  // No banner if no multiple versions exist in the chart data
  if (!hasMultipleVersions) return null;

  return (
    <Banner
      title={title}
      content={content}
      color='orange'
      icon={getSvgByName('alertCircle')}
      iconClassName={styles.icon}
      className={c(styles.container, className)}
      size='inside-card'
      variant='full'
      action={{ label: 'Update', onClick: handleUpdate }}
    />
  );
}
